import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const BadgeContainer = styled(Box)(({ variant }) => {
  const variants = {
    success: {
      backgroundColor: '#CDFEE1',
      color: '#0C5132'
    },
    default: {
      backgroundColor: 'rgba(0, 0, 0, 0.06)',
      color: '#333333'
    },
    critical: {
      backgroundColor: '#FEDAD9',
      color: '#8E1F0B'
    },
    pending: {
      backgroundColor: '#FFD6A4',
      color: '#5E4200'
    },
    activ: {
      backgroundColor: '#CDFEE1',
      color: '#0C5132'
    },
    inactiv: {
      backgroundColor: '#CDFEE1',
      color: '#99280bff'
    },
  };

  return {
    display: 'inline-flex',
    height: '20px',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '2px',
    paddingBottom: '2px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '2px',
    borderRadius: '10px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
    ...variants[variant] || variants.default
  };
});

const StatusBadge = ({ variant = 'default', text, showDot = true }) => {
  return (
    <BadgeContainer variant={variant}>
      {showDot && <span style={{ fontSize: '20px', marginBottom: '2.5px', marginRight: '4px' }}>●</span>}
      {text}
    </BadgeContainer>
  );
};

export default StatusBadge;